import { inject, Injectable } from '@angular/core';
import { IHttpErrorHandlerService, NormalizedHttpErrorValueObject } from '@gishub/domain';
import { ToastService } from './toast-service';
import { AuthProvider } from '../features/auth/shared/auth-provider';

@Injectable({ providedIn: 'root' })
export class HttpErrorHandlerService implements IHttpErrorHandlerService {
  private static readonly TOAST_COOLDOWN_MS = 8000;

  private readonly toast = inject(ToastService);
  private readonly auth = inject(AuthProvider);
  private lastToastAt = 0;

  handle(error: NormalizedHttpErrorValueObject): void {
    const now = Date.now();
    const showToast = now - this.lastToastAt >= HttpErrorHandlerService.TOAST_COOLDOWN_MS;
    if (showToast) {
      this.lastToastAt = now;
    }

    if (error.status === 401) {
      if (this.auth.state().isAuthenticated) {
        this.auth.logout();
        if (showToast) {
          this.toast.warn('Sesión expirada', 'Inicie sesión nuevamente.');
        }
      }
      return;
    }

    if (error.status === undefined) {
      if (showToast) {
        this.toast.error('Sin conexión', error.message);
      }
      return;
    }

    if (error.status >= 500) {
      if (showToast) {
        this.toast.error('Error del servidor', error.message);
      }
      return;
    }

    if (showToast) {
      this.toast.warn('Solicitud no procesada', error.message);
    }
  }
}
